import s2_1_4_sect2_img1 from '../../../../assets/images/s2_1_4_sect2_img1.png';
import s2_1_4_sect2_img2 from '../../../../assets/images/s2_1_4_sect2_img2.png';
import s2_1_4_sect2_img3 from '../../../../assets/images/s2_1_4_sect2_img3.png';
import s2_1_4_sect2_img4 from '../../../../assets/images/s2_1_4_sect2_img3.png';

import s2_1_4_sect3_img from '../../../../assets/images/s2_1_4_sect3_img.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 T11 (출시예정)</p>
        </div>

        <div className="center">
          <div className="col-flex mb-5">
            <div className="row-flex-center m-col-flex between mb-10">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_1_4_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-48 m-w-100 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  대형 스크린으로 <br />더 스마트한 광고관리
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  멀티 모달 3D 비전과 밀리 초 단위 알고리즘으로
                  <br />
                  복잡한 환경에서 장애물 회피
                </p>
              </div>
            </div>

            <div className="row-flex-center m-col-flex between mb-10 ">
              <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_1_4_sect2_img2} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-48 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  자체개발 6륜 충격 흡수 시스템
                  <br />
                  급정거시에도 안전성 보장
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  6륜 충격 흡수 차체 & 스마트 알고리즘 <br />컵 가장자리
                  1cm에서도 완벽한 보호
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none">
                <img src={s2_1_4_sect2_img2} alt="" />
              </div>
            </div>

            <div className="row-flex-center m-col-flex between">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_1_4_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-48 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  AI 자동 픽업 시스템
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  트레이 감지 99% 이상의 정확도, <br />
                  사용자 데이터 기반 지속 학습으로 더욱 정교해지는 성능
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sect3 pt-10 pb-5">
        <div className="txt-center mb-4">
          <p className="prt-bold fs-40 fc-black1  mb-1">
            49cm 초 협소 통로도 자율주행
          </p>
          <p className="prt-light fs-20 fc-777 lh-13">
            5개 입체 비전 센서와 VSLAM 5개 입체 비전 센서와 <br />
            CLAM 기술로 협소 통로로 정확한 이동
          </p>
        </div>

        <div className="flex-center mb-4">
          <img src={s2_1_4_sect3_img} alt="" />
        </div>
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
